import { render, staticRenderFns } from "./AdminSolarInverterAdd.vue?vue&type=template&id=01b6d2a8&"
import script from "./AdminSolarInverterAdd.vue?vue&type=script&lang=js&"
export * from "./AdminSolarInverterAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports